import { LoadIndicator } from "devextreme-react";

type Props = {
  message?: string;
  className?: string;
};

export default function LoadingScreen({ message, className }: Props) {
  return (
    <div
      className={`absolute left-1/2 top-1/2 flex flex-col items-center gap-2 ${className}`}
      style={{ transform: "translate(-50%, -50%)" }}
    >
      <LoadIndicator width={100} height={100} />
      {message ? <span className="text-xl font-medium">{message}</span> : null}
    </div>
  );
}
